import React from 'react'
import PropTypes from 'prop-types'
import { Panel, Margin, Text, Form, FormInput, Button } from 'shared/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory } from 'react-router-dom'
import { BottomNavigation } from '../../public/events/overview/components/bottomNavigation'

import * as styles from './styles'

const ChangePasswordComponent = ({
	form,
	onSubmit,
	isLoading,
}) => {
	const history = useHistory()

	const handleBackClick = () => {
		history.push('/profile')
	}

	return (
		<>
			{/* Mobile Header */}
			<div css={styles.mobileHeader}>
				<div css={styles.headerContainer}>
					<FontAwesomeIcon
						icon="arrow-left"
						css={styles.backArrow}
						onClick={handleBackClick}
					/>
					<div css={styles.titleContainer}>
						<Text size={16} bold css={styles.headerTitle}>
							Change Password
						</Text>
					</div>
				</div>
			</div>

			<Panel as={Form} form={form} onSubmit={onSubmit} css={styles.panel}>
				<div css={styles.contentWrapper}>
					<Margin bottom={5} css={[styles.title, styles.titleMargin]}>
						<Text as="h1" size={18} bold>
							Change Password
						</Text>
					</Margin>

					<div css={styles.pageWrapper}>
						<div css={styles.formContent}>
							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>Old Password</Text>
								<FormInput
									type="password"
									name="oldPassword"
									placeholder="********"
								/>
							</Margin>

							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>New Password</Text>
								<FormInput
									type="password"
									name="newPassword"
									placeholder="********"
								/>
							</Margin>

							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>Confirmation</Text>
								<FormInput
									type="password"
									name="confirmation"
									placeholder="********"
								/>
							</Margin>

							<Margin bottom={2} top={3}>
								<Button
									type="submit"
									medium
									css={styles.saveButton}
									disabled={isLoading}
									loading={isLoading}
								>
									<Text css={styles.buttonText}>Change Password</Text>
								</Button>
							</Margin>
						</div>
					</div>
				</div>
			</Panel>

			<BottomNavigation />
		</>
	)
}

ChangePasswordComponent.propTypes = {
	form: PropTypes.shape().isRequired,
	onSubmit: PropTypes.func.isRequired,
	isLoading: PropTypes.bool,
}

ChangePasswordComponent.defaultProps = {
	isLoading: false,
}

export default ChangePasswordComponent 